<template>
  <Transition name="toast-animation">
    <div v-if="isVisible" class="toast">
      {{ message }}
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useToast } from '@/composables/useToast'

const { isVisible, message } = useToast()
</script>

<style scoped>
.toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: theme('colors.stone.100');
  color: theme('colors.stone.900');
  padding: 10px 20px;
  border-radius: 5px;
  z-index: 1000;
  pointer-events: none;
  white-space: nowrap;

  .dark & {
    background-color: theme('colors.stone.900');
    color: theme('colors.stone.50');
  }
}

.toast-animation-enter-active,
.toast-animation-leave-active {
  transition: all 0.3s ease-in-out;
}

.toast-animation-enter-from,
.toast-animation-leave-to {
  opacity: 0;
  top: -20px;
}
</style>
